export enum PirumProjects {
  REPO = "repo",
  CCS = "ccs",
  COACS = "coacs",
  FOS = "fos",
  SFTR = "sftr",
}
